import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';
import '../Assets/CSS/paginationView.css';
interface props {
    tabs: any,
    handleClick: Function,
    totalCount: any,
    handleSubmit: Function,
};
const PaginationView = ({ tabs, handleClick, totalCount, handleSubmit }: props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event: any, newPage: number) => {
        setPage(newPage);
        handleSubmit(event, newPage, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event:any) => {
        const newLimit = parseInt(event.target.value, 10)
        setRowsPerPage(newLimit);
        setPage(0);
        handleSubmit(event, 0, newLimit);
    };
    return (
        <div className='pagination-view d-lg-flex align-items-center d-md-block d-sm-block d-block'>
            {tabs?.length > 0 ?
                <div className="btn-group" role="group">
                    <button type="button" className="btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 outline fs-6 active">Export Details</button>
                    {tabs?.map((tab: string, index: number) => {
                        return (
                            <button type="button" className="btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 outline fs-6">{tab}</button>
                        )
                    })}
                    <button type="button" className="btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 outline fs-6" onClick={() => handleClick()}>Add Employee</button>
                </div>
                :
                null}
            <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
}

export default PaginationView;